import React from 'react'

export const Folder = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_1141)'>
      <path
        d='M22 11.255C20.652 10.3159 19.0167 9.8808 17.3802 10.0259C15.7438 10.171 14.2105 10.8871 13.0488 12.0488C11.8871 13.2105 11.171 14.7438 11.0259 16.3802C10.8808 18.0167 11.3159 19.652 12.255 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H10.414L12.414 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V11.255ZM18 22C16.6739 22 15.4021 21.4732 14.4645 20.5355C13.5268 19.5979 13 18.3261 13 17C13 15.6739 13.5268 14.4021 14.4645 13.4645C15.4021 12.5268 16.6739 12 18 12C19.3261 12 20.5979 12.5268 21.5355 13.4645C22.4732 14.4021 23 15.6739 23 17C23 18.3261 22.4732 19.5979 21.5355 20.5355C20.5979 21.4732 19.3261 22 18 22ZM16.707 19.708C17.267 19.9759 17.8962 20.0635 18.5081 19.9588C19.1199 19.854 19.6842 19.5621 20.1231 19.1231C20.5621 18.6842 20.854 18.1199 20.9588 17.5081C21.0635 16.8962 20.9759 16.267 20.708 15.707L16.707 19.707V19.708ZM15.292 18.293L19.293 14.293C18.733 14.0251 18.1038 13.9375 17.4919 14.0422C16.8801 14.147 16.3158 14.4389 15.8769 14.8779C15.4379 15.3168 15.146 15.8811 15.0412 16.4929C14.9365 17.1048 15.0241 17.734 15.292 18.294V18.293Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_1141'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
